import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {MvkList} from "../../model";
import {AccessJson, MvkFilter} from "@amlCore/models";
import {RegistriesService} from "../../service";
import {RegistriesAccessEnum} from "@amlCore/enums";
import {TableService, UserService, VisitedService} from "@amlCore/services";
import {Utils} from "@amlCore/utils";
import {IDataResponse} from "@amlCore/interfaces";


@Component({
  selector: 'app-registry-mvk-list',
  templateUrl: './mvkList.component.html'
})
export class MvkListComponent extends TableReactiveUrlController implements OnInit {

  isShowVisited = true;

  constructor(private regSrv: RegistriesService,
              private userSrv: UserService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'name', dir: 'ASC'});
  }
  dataList: Array<MvkList> = [];
  isAll = true;
  id: string;
  access: AccessJson;
  goBack = Utils.goBack;
  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_MVK);
    this.activatedRoute.params.subscribe(params => {
      this.id = params.id;
      this.activatedRoute.queryParams.subscribe(
        data => {
          this.isAll = !this.id;
          const paramsData = this.syncParams(data);
          paramsData.id = this.id;
          this.loadList(paramsData);
        });
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data: MvkFilter) {
    const filter = this.tableService.getFilterSubject(data) as MvkFilter;
    return this.getFilterPlanObject(filter);
  }

  public onPageChange(params: MvkFilter) {
    const filter = this.getParams({...params, ...this.filter}) as MvkFilter;
    filter['isAll'] = this.isAll;
    this.navigate(filter);
  }

  public onSearch() {
    const params = this.getSearchPage(this.filter) as MvkFilter;
    this.onPageChange(params);
  }

  public edit(data: MvkList) {
    window.open('registries/mvk/' + data.decisionId + '/' + data.subjectId, '_blank');
  }

  private loadList(params?: MvkList) {
    this.regSrv.getMvkList(this.getParams(params)).subscribe((data: IDataResponse<MvkList>) => {
      this.dataList = data.content;
      this.total = data.totalSize;
    });
  }

  getIdOfBase(item: MvkList): string {
    return item.base ? item.subjectId : item.parentId;
  }
}
